/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactHighCharts from 'react-highcharts';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment-timezone';
import _ from 'lodash';
import { translate } from 'react-i18next';
import Highcharts from 'highcharts';
import { placeholderConfig } from '../Highcharts';

const Plot = ReactHighCharts.withHighcharts(Highcharts);

@translate(['dashboard'], { wait: true })
class DistancePlot extends Component {
  constructor(props) {
    super(props);

    this.handleEvent = this.handleEvent.bind(this);
  }

  shouldComponentUpdate(props) {
    if (
      this.props.distanceReport === props.distanceReport &&
      this.props.noRidesEver === props.noRidesEver &&
      this.props.currentLanguage === props.currentLanguage
    ) {
      return false;
    }
    return true;
  }

  getRangeLabel() {
    const [m1, m2] = this.props.range;
    m1.locale(this.props.currentLanguage);
    m2.locale(this.props.currentLanguage);
    return `${moment(m1).format('DD MMMM')} - ${moment(m2).format(
      'DD MMMM YYYY',
    )}`;
  }

  handleEvent(e, picker) {
    this.props.handleEvent(e, picker);
  }

  render() {
    const { t, noRidesEver } = this.props;
    const date = this.props.range[0].format('YYYY,M,D').split(',');
    const start = Date.UTC(date[0], date[1] - 1, date[2]);
    const pointInterval = 86400000;
    const daysCount = this.props.range[1].diff(this.props.range[0], 'days') + 1;
    const journeysDurations = this.props.durationReport.values;
    const journeysCosts = this.props.fuelCostReport.values
      ? this.props.fuelCostReport.values.map(i => Math.round(i))
      : [];
    const journeysExpenses = this.props.fuelConsumptionReport.values
      ? this.props.fuelConsumptionReport.values.map(i => i.toFixed(2))
      : [];
    const journeysDistances = this.props.distanceReport.values.map(
      (value, index) => ({
        y: value / 1000,
        ind: [
          journeysDurations[index],
          journeysCosts[index],
          journeysExpenses[index],
        ],
        className: value === 0 ? 'disabled' : '',
      }),
    );
    let config = {
      chart: { type: 'column' },
      tooltip: {
        formatter() {
          // eslint-disable-line func-names
          let s = `<div class="tooltipDate">${Highcharts.dateFormat(
            '%e %b %Y',
            this.x,
          )}</div>`;
          for (const point of this.points) {
            let hour = Math.floor(point.point.ind[0] / 3600);
            const days = hour > 23 ? Math.floor(hour / 24) : 0;
            const min = Math.floor((point.point.ind[0] - hour * 3600) / 60);
            if (days > 0) hour -= days * 24;
            let hourHtml;
            if (days === 0) {
              hourHtml = `<div class="tooltipWrap"><span class="titile">${t(
                'dashboard:time',
              )}</span><span>${hour}</span>${t(
                'dashboard:hours',
              )}<span>${min}</span>${t('dashboard:min')}</div>`;
            } else if (days > 0 && hour > 0) {
              hourHtml = `<div class="tooltipWrap"><span class="titile">${t(
                'dashboard:time',
              )}</span><span>${days}</span>${t(
                'dashboard:time',
              )}<span>${hour}</span>${t(
                'dashboard:hours',
              )}<span>${min}</span>${t('dashboard:min')}</div>`;
            } else {
              hourHtml = `<div class="tooltipWrap"><span class="titile">${t(
                'dashboard:time',
              )}</span><span>${min}</span>${t('dashboard:min')}</div>`;
            }
            s +=
              `<div class="tooltipWrap active"><span>${Math.round(
                point.y * 10,
              ) / 10}${t(
                'dashboard:km',
              )}</span></div>${hourHtml}<div class="tooltipWrap">` +
              `<div class="tooltipWrap"><span class="titile">${t(
                'dashboard:consumption',
              )}</span> <span>${_.round(point.point.ind[2], 1).toLocaleString(
                'ru',
              )}${t('dashboard:l')}</span></div>`;
          }
          return s;
        },
      },
      plotOptions: {
        series: {
          pointStart: start,
          pointInterval,
        },
      },
      series: [
        {
          name: t('dashboard:timeTab'),
          color: 'rgba(116,223,142,0.4)',
          states: { hover: { color: 'rgba(116,223,142,1)' } },
          data: journeysDistances,
        },
      ],
    };
    config = noRidesEver ? placeholderConfig(start) : config;
    const totalDistance = Math.round(
      journeysDistances.reduce((prev, curr) => prev + curr.y, 0),
    );
    const averageDistanceByDay = Math.round(
      journeysDistances.reduce((prev, curr) => prev + curr.y, 0) / daysCount,
    );
    return (
      <div id="timeTab" className="tab active">
        <div className="graph-section__status">
          <div className="graph-section__filterWrap">
            <div className="filterBlock">
              <div className="filterBlockDrop">
                <DateRangePicker
                  key={this.props.currentLanguage}
                  onHide={this.handleEvent}
                  startDate={moment(this.props.range[0])}
                  endDate={moment(this.props.range[1])}
                  maxDate={moment()}
                  minDate={moment('01/01/2012', 'DD/MM/YYYY')}
                  alwaysShowCalendars={true} // eslint-disable-line react/jsx-boolean-value
                  showDropdowns={false}
                  showWeekNumbers={false}
                  timePicker={false}
                  ranges={{
                    [t('dashboard:last_7_days')]: [
                      moment().subtract(6, 'days'),
                      moment(),
                    ],
                    [t('dashboard:last_30_days')]: [
                      moment().subtract(29, 'days'),
                      moment(),
                    ],
                    [t('dashboard:last_90_days')]: [
                      moment().subtract(89, 'days'),
                      moment(),
                    ],
                  }}
                  showCustomRangeLabel={false}
                  opens={'left'}
                  format={'DD.MM.YYYY'}
                  locale={{
                    format: 'DD.MM.YYYY',
                    customRangeLabel: 'Custom Range',
                    firstDay: 1,
                  }}
                  dateLimit={{ days: 90 }}
                >
                  <div className="pull-right reportrange">
                    <span>{this.getRangeLabel()}</span> <b className="caret" />
                  </div>
                </DateRangePicker>
              </div>
            </div>
          </div>
          <div className="graph-section__filterInfo">
            <div className="graph-section__filterInfo__col">
              <div className="status">
                {averageDistanceByDay} {t('dashboard:km')}
              </div>
              <div className="title">{t('dashboard:average')}</div>
            </div>
            <div className="graph-section__filterInfo__col">
              <div className="status">
                {totalDistance} {t('dashboard:km')}
              </div>
              <div className="title">{t('dashboard:total')}</div>
            </div>
          </div>
        </div>
        <Plot
          config={config}
          domProps={{
            id: 'sectionGraphDrivingTime',
            className: 'graph-section__graph',
          }}
        />
      </div>
    );
  }
}

DistancePlot.PropTypes = {
  range: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
  handleEvent: PropTypes.func,
  fuelConsumptionReport: PropTypes.object,
  fuelCostReport: PropTypes.object,
  durationReport: PropTypes.object,
  distanceReport: PropTypes.object,
};

export default connect(
  state => ({
    noRidesEver: !(
      !state.rides.areJourneysEverLoaded || state.rides.areJourneysEverExist
    ),
    fuelConsumptionReport:
      state.dashboard.filteredReports.fuelConsumptionReport,
    fuelCostReport: state.dashboard.filteredReports.fuelCostReport,
    durationReport: state.dashboard.filteredReports.durationReport,
    distanceReport: state.dashboard.filteredReports.distanceReport,
    currentLanguage: state.langs.currentLanguage,
  }),
  () => ({}),
)(DistancePlot);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Plots/DistancePlot.js